import useGetNewsTipCommentSimpleViewData from './useGetNewsTipCommentSimpleViewData'

export default useGetNewsTipCommentSimpleViewData
